module.exports = __webpack_public_path__ + "static/media/speech-bubbles.b9fcdbdc.svg";